<template>
    <div class="search-result border rounded" v-if="$store.getters.GET_SEARCHED_ADDRESSES.fetched && $store.getters.GET_SEARCHED_ADDRESSES.list.length > 0">
        <div class="search-result-wrapper skiptranslate">
            <div class="search-result-wrapper-item d-flex align-items-center pl-4" v-for="l of $store.getters.GET_SEARCHED_ADDRESSES.list" :key="l.id" @click="select(l)" tabindex="0" @keydown="(event) => {selectKeyEvent(event, l)}">
                <div>{{ l.displayName }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        mounted() {
            setTimeout(()=>{
                this.$store.dispatch('clearSearchedAddresses')
            },1000);
        },
        computed: {
            personalInfo : function(){
                return this.$store.getters.GET_PERSONAL_INFO;
            },
            yourEmail: function () {
                return this.personalInfo && this.personalInfo.email ? this.personalInfo.email : '';
            },
            yourType: function () {
                return this.personalInfo && this.personalInfo.type ? this.personalInfo.type.toLowerCase().trim() : 'resident';
            }
        },
        methods: {
            select(address) {
                const addressSettingList = this.$store.getters.GET_SERVICE_GROUP_ADDRESS.list;

                if (!addressSettingList || !address) {
                    return;
                }

                const activeAddressSetting = addressSettingList.find(addressSetting => {
                    var emails = addressSetting.cso_emails.split(',');
                    return Number(addressSetting.website_action) == Number(address.websiteAction) &&
                        addressSetting.popup_display &&
                        (
                            !addressSetting.allow_cso ||
                            this.yourType != 'cso' || !(
                                addressSetting.allow_cso && (
                                    addressSetting.cso_emails == "" || (
                                        addressSetting.cso_emails != "" &&
                                        emails.map(x => x.trim()).includes(this.yourEmail.toLowerCase().trim())
                                    )
                                )
                            )
                        )
                });

                if (activeAddressSetting) {
                    const bookingSearchComp         = this.$parent;
                    const bookingServiceHeaderComp  = bookingSearchComp.$parent;
                    const bookingComp               = bookingServiceHeaderComp.$parent;

                    // Clear suggested addresses
                    this.$store.commit('SET_SEARCHED_ADDRESSES', { fetched: false, list: [] });

                    // Clear parent's search field
                    this.$emit('clearPattern');

                    bookingComp.$refs.alertAddressSearchValidation.show(activeAddressSetting.popup_message, 'OK');
                } else {
                    this.$store.dispatch('setActiveAddress', address);
                }
            },
            selectKeyEvent(event, address){
                if (event.keyCode == 32 || event.keyCode == 13) {
                    event.preventDefault();
                    this.select(address)
                }
            }
        },
    }
</script>